import React from "react";

import { format } from "@gamedev-web/gamedev-sdk-core";
import { Close, Refresh, Search } from "@gaming/xds-react-js-icons";

import { conceptsManagerStyles } from "../../../../components/ConceptsManager";
import { useStrings } from "../../../../localization/localizationHelpers";
import * as styles from "../../AdminPage.module.css";

type AdminTableToolbarProps = Readonly<{
  children: React.ReactNode;
  closeSearchLabel: string;
  hasActiveFilters: boolean;
  isRefreshing: boolean;
  onClear: () => void;
  onRefresh: () => void;
  onSearchChange: (value: string) => void;
  refreshLabel: string;
  resultCount: number;
  searchLabel: string;
  searchQuery: string;
}>;

export const AdminTableToolbar = ({
  children,
  closeSearchLabel,
  hasActiveFilters,
  isRefreshing,
  onClear,
  onRefresh,
  onSearchChange,
  refreshLabel,
  resultCount,
  searchLabel,
  searchQuery,
}: AdminTableToolbarProps) => {
  const [clearLabel, resultCountFormat] = useStrings(
    "partnerAdminClearFiltersLabel",
    "partnerAdminResultCountFormat"
  );

  return (
    <div className={styles.tableToolbar}>
      <div className={`${conceptsManagerStyles.searchExpanded} ${styles.tableSearch}`}>
        <span className={conceptsManagerStyles.searchIcon}>
          <Search />
        </span>
        <input
          className={conceptsManagerStyles.searchInput}
          type="search"
          aria-label={searchLabel}
          placeholder={searchLabel}
          value={searchQuery}
          onChange={event => onSearchChange(event.target.value)}
        />
        {searchQuery && (
          <button
            type="button"
            className={conceptsManagerStyles.searchClose}
            aria-label={closeSearchLabel}
            onClick={() => onSearchChange("")}
          >
            <Close />
          </button>
        )}
      </div>
      <div className={styles.tableControls}>{children}</div>
      {hasActiveFilters && (
        <button type="button" className={styles.clearFiltersButton} onClick={onClear}>
          <Close />
          {clearLabel}
        </button>
      )}
      <span className={styles.resultCount}>{format(resultCountFormat, String(resultCount))}</span>
      <button
        type="button"
        className={conceptsManagerStyles.iconButton}
        aria-label={refreshLabel}
        disabled={isRefreshing}
        onClick={onRefresh}
      >
        <Refresh />
      </button>
    </div>
  );
};
